import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Upload, CheckCircle2, Clock, AlertCircle } from "lucide-react";

export default function ChapterUploadCard({ chapter, uploads, onUpload }) {
  const latestUpload = uploads
    .filter((u) => u.chapter_id === chapter.id)
    .sort((a, b) => b.version_number - a.version_number)[0];

  const statusIcon = {
    UPLOADED: <Clock className="w-4 h-4 text-blue-500" />,
    APPROVED: <CheckCircle2 className="w-4 h-4 text-green-500" />,
    REJECTED: <AlertCircle className="w-4 h-4 text-red-500" />,
  };

  return (
    <Card
      data-testid={`chapter-card-${chapter.id}`}
      className="bg-white/80 backdrop-blur-sm border-2 border-slate-200 hover:border-purple-200 transition-all"
    >
      <CardContent className="p-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-sm font-bold text-purple-600">
                Ch. {chapter.chapter_number}
              </span>
              {chapter.chapter_title && (
                <span className="text-sm text-black truncate">
                  {chapter.chapter_title}
                </span>
              )}
            </div>

            {latestUpload ? (
              <div className="flex items-center gap-2">
                {statusIcon[latestUpload.status]}
                <Badge variant="outline" className="text-xs">
                  v{latestUpload.version_number}
                </Badge>
                <span className="text-xs text-slate-500">
                  {new Date(latestUpload.uploaded_at).toLocaleDateString()}
                </span>
              </div>
            ) : (
              <p className="text-xs text-slate-500">No upload yet</p>
            )}
          </div>

          <Button
            size="sm"
            variant="outline"
            onClick={() => onUpload(chapter.id)}
            data-testid={`upload-chapter-${chapter.id}`}
          >
            <Upload className="w-4 h-4 mr-1" />
            {latestUpload ? `Upload v${latestUpload.version_number + 1}` : "Upload"}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
